<script lang="ts">
  import { IconPhone } from "@tabler/icons-svelte";

  import Tabs from "@/lib/components/tabs/tabs.svelte";
  import LocalNumbers from "./form-inputs/local-numbers.svelte";
  import TollFreeNumbers from "./form-inputs/toll-free-numbers.svelte";

  export let theme: "phone-numbers" | "default";
  export let preselectedAreaCode: string;
  export let options: string[];
  export let title: string;

  const themeConfigs = {
    default: {
      classes: {
        contentBox: "content-box",
      },
    },
    ["phone-numbers"]: {
      classes: {
        contentBox: "content-box",
      },
    },
  };

  const themeConfig = themeConfigs[theme] || themeConfigs.default;

  console.log("themeConfig", themeConfig, themeConfigs[theme]);

  let activeTab = 0;

  const isTabsShowed = options.length > 1;

  if (options.length === 1) {
    activeTab = options[0] === "toll-free" ? 1 : 0;
  }
</script>

<div class={themeConfig.classes.contentBox}>
  <div class="font-l flex gap-5 align-center font-medium mb-20">
    <IconPhone class="block size-20 color-gray" />
    {title}
  </div>

  {#if isTabsShowed}
    <Tabs
      bind:active={activeTab}
      tabs={[{ name: "Local Numbers" }, { name: "Toll Free Numbers" }]}
    >
      {#if activeTab === 0}
        <LocalNumbers {theme} {preselectedAreaCode} />
      {:else if activeTab === 1}
        <TollFreeNumbers {theme} />
      {/if}
    </Tabs>
  {/if}

  {#if !isTabsShowed}
    {#if activeTab === 0}
      <LocalNumbers {theme} {preselectedAreaCode} />
    {:else if activeTab === 1}
      <TollFreeNumbers {theme} />
    {/if}
  {/if}
</div>
